import ApiConnector from '@/backend/apiModels/CRUDrequest'
import { useRouter } from 'vue-router';
import { useErrorHandler } from '@/hooks/errorHandler';
import { createToaster } from "@meforma/vue-toaster";
import { downloadBlobResponse } from '@/backend/download';
import { tmsRequestMethod, tmsRequestParams } from './tmsRequest';

const toaster = createToaster();
const api = new ApiConnector('trips')
const namespaced = true
// const router = useRouter()

const state = {
  options:{
    payment_methods:[],
    payments_term:[],
  },

  tripPage:{
    item:{},
    loading:false,
    comments:[],
  },
  
  cargosPage:{
    trips:[],
    currentPage: 1,
    totalPages:1,
    loading:false,
    filtered:false,
  },
  
  filters:{
    cargolist:{
      selectedManager:null,
      selectedTrancportType:'',
      selectedDepartureCity:null,
      selectedDestinationCity:null,
      selectedStatus:'',
      selectNumber:null,
      selectWorkStatus:null,
      startDate:null,
      endDate:null,
      belated:'',
      is_top:null,
      open_trip:null,
      resync_blocked:false,
    },
  },
};

const mutations = {
  clearInput(state){
    state.tripPage.item = {}
  },
  routesUpdate(state,response){
    // Ищем индекс элемента с совпадающим id
    const index = state.tripPage.item.route_point.findIndex(
      (route) => route.id === response.id
    );

    // Если элемент найден, обновляем его
    if (index !== -1) {
      state.tripPage.item.route_point[index] = response;
    } else {
      console.warn('Маршрут с таким id не найден:', response.id);
    }
  },
  carsUpdate(state,response){
    state.tripPage.item.executor.car = response
  },
  trailersUpdate(state,response){
    state.tripPage.item.executor.trailer = response
  },
  driversUpdate(state,response){
    state.tripPage.item.executor.driver = response
  },
  companiesUpdate(state,response){
    state.tripPage.item.executor.company = response
  },
  executorsUpdate(state,response){
    state.tripPage.item.executor = response
  },
  
  resetFilters(state){
    state.filters.cargolist.selectedManager=null
    state.filters.cargolist.selectedTrancportType=''
    state.filters.cargolist.selectedDepartureCity=null
    state.filters.cargolist.selectedDestinationCity=null
    state.filters.cargolist.selectedStatus=''
    state.filters.cargolist.selectNumber=null
    state.filters.cargolist.selectWorkStatus=null
    state.filters.cargolist.startDate=null
    state.filters.cargolist.endDate=null
    state.filters.cargolist.belated=''
    state.filters.cargolist.is_top = null
    state.filters.cargolist.open_trip = null
    state.filters.cargolist.resync_blocked = false
    state.cargosPage.filtered = false
  },

  setFiltered(state, value){
    state.cargosPage.filtered = value
  },

  setComments(state, response){
    state.tripPage.comments = response
  },

  setTrip(state, response){
    state.tripPage.item = {}
    state.tripPage.item = response
  },

  setCargos(state, response){
    state.cargosPage.trips = response.trips
    state.cargosPage.currentPage = response.current_page
    state.cargosPage.totalPages = response.total_pages
  },

  setLoading(state, { loading, status }) {
    state[loading].loading = status;
  },

  setDataItems(state, {response}) {
    state.currentPage = response.value.current_page
    state.totalPages = response.value.total_pages
    state.items = response.value
  },

  setDataItem(state,{  response }){
    state.item = response.value
  },

  setFilter(state,value ){
    state.filters.cargolist = value
  },
};

const getters = {
  isModifyFilter(state){
    return state.filters.cargolist.selectedManager
    || state.filters.cargolist.selectedTrancportType
    || state.filters.cargolist.selectedDepartureCity
    || state.filters.cargolist.selectedDestinationCity
    || state.filters.cargolist.selectedStatus
    || state.filters.cargolist.selectNumber
    || state.filters.cargolist.selectWorkStatus
    || state.filters.cargolist.startDate
    || state.filters.cargolist.endDate
    || state.filters.cargolist.belated
    || state.filters.cargolist.is_top
    || state.cargosPage.filtered
    || state.filters.cargolist.open_trip
    || state.filters.cargolist.resync_blocked
  }
};

const actions = {
  async waitInterval({ dispatch },{func,params,seconds=120}){
      setTimeout(() => {
        dispatch(func,params);  
      }, seconds*1000);
  },

  async startLoading({ commit },{request,loading=null}){
    if(loading) commit('setLoading', {loading,status:true})
    try{
      await request()      
    }catch(error){
      useErrorHandler(error)
    }  
  },

  async addComment({ dispatch, commit },{trip_id,form}){
    const url = trip_id+'/comment'
    const { response, request } = api.post(url,{form})
    await dispatch('startLoading',{request})
    if(response.value) commit('setComments',response.value)
  },

  async getComment({ dispatch, commit },{trip_id}){
    const url = trip_id+'/comment'
    const { response, request } = api.get(url,{params:{}})
    await dispatch('startLoading',{request})
    if(response.value) commit('setComments', response.value)
  },

  async getTrip({ dispatch, commit },{trip_id,silence}){
    const { response, request } = api.get(trip_id.toString(),{params:{}})
    await dispatch('startLoading', { request, loading: !silence ? 'tripPage' : undefined });
    if(response.value){
      commit('setTrip',response.value)
    }
    commit('setLoading', {loading:'tripPage',status:false})
  },

  async getCargos({ dispatch, commit, state, rootState },{page,silence}){
    if (state.filters.cargolist.resync_blocked) {
      const targetPage = page || state.cargosPage.currentPage || 1
      const form = state.filters.cargolist
      const filters = { page: targetPage }
      if (form.selectNumber) filters.cargo_trip_id = form.selectNumber
      if (!silence) commit('setLoading', { loading: 'cargosPage', status: true })
      try {
        await dispatch('tripsResync/getBlockedTrips', { force: true, filters }, { root: true })
        const blocked = rootState.tripsResync?.blockedTrips || []
        const total = rootState.tripsResync?.totalItems || 0
        const perPage = rootState.tripsResync?.perPage || 50
        commit('setFiltered', true)
        commit('setCargos', {
          trips: blocked,
          current_page: targetPage,
          total_pages: Math.max(1, Math.ceil(total / perPage)),
        })
      } catch (error) {
        useErrorHandler(error)
      }
      if (!silence) commit('setLoading', { loading: 'cargosPage', status: false })
      return
    }

    const endpoint = state.cargosPage.filtered ? 'filters' : '';
    const form = state.filters.cargolist
    const params = {page}

    const { response, request } = api[endpoint ? 'post' : 'get'](endpoint, {form,params});
    
    await dispatch('startLoading', { request, loading: !silence ? 'cargosPage' : undefined });
    if (response.value) {
      commit('setCargos', response.value);
    }
  
    if (!silence) {
      commit('setLoading', { loading: 'cargosPage', status: false });
    }
  },

  async approval({ dispatch, commit, rootGetters },{trip_id,form}){
    if (!rootGetters.isTripApprovalEnabled) return
    const { response, request } = api.put('/approval/'+trip_id,form)
    await dispatch('startLoading',{request,loading:'tripPage'})

    if(response.value){
      commit('setTrip', response.value)
      toaster.success("Данные обновлены");
    }
    commit('setLoading', {loading:'tripPage',status:false})
  },

  async updateTrip({ dispatch, commit },{trip_id,form}){
    const { response, request } = api.put(trip_id,form)
    await dispatch('startLoading',{request,loading:'tripPage'})
    
    if(response.value){
      commit('setTrip', response.value)
      toaster.success("Данные обновлены");
    }else{
      await dispatch('getTrip',{trip_id,silence:true})
    }
    
    commit('setLoading', {loading:'tripPage',status:false})
  },

  async getFile(){
    try {
      const response = await api.getFile('generate_excel',state.filters.cargolist)

      // Создайте объект Blob с данными файла
      const blob = new Blob([response.data]);

      // Создайте ссылку на скачивание файла
      const url = window.URL.createObjectURL(blob);

      // Создайте элемент "a" для скачивания файла
      const a = document.createElement('a');
      a.style.display = 'none';
      a.href = url;
      a.download = 'output.xlsx'; // Установите имя файла

      // Добавьте элемент "a" в DOM и нажмите на него
      document.body.appendChild(a);
      a.click();

      // Очистите URL и уберите элемент "a"
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
      
    } catch (error) {
      console.error('Ошибка при генерации Excel файла:', error);
    }
  },

  async addTripTemlate({dispatch,commit},ids){
    const { response, request } = api.put('/template',{ids})
    try{
      await request()
      if(response.value){
        await commit('setCargos', response.value)
      }
    }catch(error){
      console.log(error)
    } 
    
  },

  async getTmsItem({commit},{trip_id,type,sendAsOwn=false}){
    const link = trip_id+'/tms/'+type
    const method = tmsRequestMethod(type)
    const params = tmsRequestParams(type, { sendAsOwn })
    const { response, request } = method === 'post'
      ? api.post(link,{form:{},params})
      : api.get(link,{params})
    commit('setLoading', {loading:'tripPage',status:true})
    try {
      await request()
      if(response.value){
        commit('setTrip',response.value)
      }
      return response.value
    } catch (error) {
      useErrorHandler(error)
      throw error
    } finally {
      commit('setLoading', {loading:'tripPage',status:false})
    }
  },

  async getOptions({ dispatch },{name}){
    const { response, request } = api.get(name,{params:{}})
    await dispatch('startLoading',{request})
    if(response.value){
      state.options[name] = response.value
    }
  },

  async updateStatus({dispatch,commit},{link,form={}}){
    const { response, request } = api.putFromLink(link,form)
    await dispatch('startLoading',{request,loading:'tripPage'})

    if(response.value){
      commit('setTrip', response.value)
      toaster.success("Данные обновлены");
    }
    commit('setLoading', {loading:'tripPage',status:false})
  },

  async changeCustomer({dispatch,commit},link){
    
    const { response, request } = api.putFromLink(link)
    await dispatch('startLoading',{request,loading:'tripPage'})

    if(response.value){
      commit('setTrip', response.value)
      toaster.success("Данные обновлены");
    }
    commit('setLoading', {loading:'tripPage',status:false})
  },

  async updateRoutePoints({dispatch,commit},{link,route}){
    
    const { response, request } = api.putFromLink(link,route)
    await dispatch('startLoading',{request,loading:'tripPage'})
    if(response.value){
      commit('routesUpdate', response.value)
      toaster.success("Данные обновлены");
    }
    commit('setLoading', {loading:'tripPage',status:false})
  },
  
  async sendOrder({ dispatch }, id) {
    let response
    try {
      response = await api.getBlob('send_order/' + id)
    } catch (e) {
      let detail = e?.message || 'Не удалось сформировать бланк заявки'
      const data = e?.response?.data
      try {
        if (data && typeof data.text === 'function') {
          const text = await data.text()
          try {
            const parsed = JSON.parse(text)
            detail = parsed.detail || parsed.message || text || detail
          } catch {
            detail = text || detail
          }
        } else if (typeof data?.detail === 'string') {
          detail = data.detail
        }
      } catch {
        // leave default detail
      }
      throw new Error(typeof detail === 'string' ? detail : 'Не удалось сформировать бланк заявки')
    }
    await downloadBlobResponse(response, `zayavka_${id}.docx`)
    toaster.success('Бланк заявки сформирован')
    try {
      await dispatch('applications/getApplication', id, { root: true })
    } catch (e) {
      // файл уже скачан — состояние кнопки обновится при следующем открытии
    }
    return response
  },

};

export default {
  state,
  mutations,
  getters,
  actions,
  namespaced
};
